import { Button, ModalBody, ModalFooter, Td, Tr } from "@chakra-ui/react";
import { Modal, Table, Tag } from "components";
import { useConsultant, useConsultantVouchers } from "hooks";

export default function Vouchers({ data, ...props }){

    const consultant = useConsultant(data?.id)
    const vouchers = useConsultantVouchers(data?.id)

    const columns = [{ children: 'Kit' }, { children: 'Disponível', isNumeric: true }]

    return(
    <Modal title="Vouchers do consultor" {...props}>
        <ModalBody>
            <Table columns={columns}>
                { vouchers.data?.itens?.map(item => <Item key={item.label} data={item} />) }
            </Table>
        </ModalBody>
        <ModalFooter>
            <Button size="sm" children="Fechar" onClick={props.onClose} />
        </ModalFooter>
    </Modal>
    )
}

const Item = ({ data }) => {
    return(
    <Tr>
        <Td>{data?.label}</Td>
        <Td isNumeric><Tag size="sm" colorScheme="green">{data?.available} disponíveis</Tag></Td>
    </Tr>
    )
}